import { EPermissoes } from '@/enums/ePermissoes';
export default [
  {
    description: 'Unidade Grupo',
    path: 'unidade-grupo',
    name: 'unidadegrupo',
    component: () => import('@/views/gestao/unidade-grupo/Index.vue'),
    goesToMenu: true,
    meta: {
      permissions: [EPermissoes.CadastroObra],
      grupos: [],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão Unidade Grupo',
    path: 'unidade-grupo/incluir/:chave/:ordem',
    parent: 'unidadegrupo',
    name: 'unidadegrupoinsert',
    component: () => import('@/views/gestao/unidade-grupo/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'unidadegrupo',
      permissions: [EPermissoes.CadastroObra],
      grupos: []
    }
  },
  {
    description: 'Edição de Unidade Grupo',
    path: 'unidade-grupo/editar/:id',
    parent: 'unidadegrupo',
    name: 'unidadegrupoupdate',
    component: () => import('@/views/gestao/unidade-grupo/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'unidadegrupo',
      permissions: [EPermissoes.CadastroObra],
      grupos: []
    }
  }
];
